module.exports = __webpack_public_path__ + "647f3654373165e51135a4fddf0006a9.woff2";